import React from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';

import SendButton from './SendButton';
import { useAppContext } from '../../context';
import CalculateCourseComponent from '../CalculateCourse';
import InfoComponent from '../Info';



const Calculator: React.FC = () => {
  const { onlineCourse } = useAppContext();


  return (
    <Paper
      elevation={3}
      sx={{
        p: { xs: 2, md: 4 },        // Responsive padding
        margin: "auto",
        borderRadius: 2,
        maxWidth: "900px",
      }}
    >
      <Typography
        className="font-helviteca text-blue"
        variant="h4"
        textAlign="center"
        gutterBottom
      >
        კალკულატორი
      </Typography>

      <Typography
        className="font-helviteca text-blue-80"
        
        textAlign="center"
        gutterBottom
        sx={{
          fontSize: '1rem'
        }}
      >
        აირჩიეთ კონვერტაციის ტიპი, რომლის მიხედვითაც გსურთ ვალუტის გადაყვანა
      </Typography>

      {/* Form Wrapper */}
      <CalculateCourseComponent mode="MAIN"/>
      {/* CALCULATE BUTTON */}
      <Box
        sx={{ mt: 4, textAlign: "center" }}
      >
        {onlineCourse && <SendButton />}
      </Box>

      {<InfoComponent />}

    </Paper>

  );
};

export default Calculator;